import { useMemo } from 'react';
import { useProperties } from '@/hooks/useProperties';
import { Property } from '@/types/property';

export const usePropertiesData = () => {
  const { data = [], isLoading, error } = useProperties();

  const available = useMemo(
    () => data.filter((p: Property) => p.available),
    [data],
  );

  const ids = useMemo(() => available.map((p) => p.id), [available]);

  return {
    properties: data,
    availableProperties: available,
    propertyIds: ids,
    isLoading,
    error,
  };
};
